import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
@Component({
  selector: 'text-complemento',
  templateUrl: './text-complemento.component.html',
  styleUrls: ['./text-complemento.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextComplementoComponent implements OnInit {
  
  constructor() {}

  ngOnInit() { }

}
